"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var moment = require('moment');

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var sortBy = require('lodash/sortBy');

var uniq = require('lodash/uniq');

var ShineProducts = require('../../products/index');

var ShinePricing = require('../../pricing/index');

var ShineShipping = require('../../shipping/index');

var ShinePrinting = require('../../printing/index');

var PRODUCT_CONSTANTS = require('../../products/constants');

var Address = require('./Address');

var OrderNote = require('./OrderNote');

var PriceAdjustment = require('./PriceAdjustment');

var DESIGNATIONS = {
  sample_orders: 'sample_orders',
  orders: 'orders',
  table_numbers: 'table_numbers',
  custom_samples: 'custom_samples'
};

function hasLetterpress(_ref) {
  var product_type = _ref.product_type,
      components = _ref.components;

  if (product_type.match(/sample/i)) {
    return false;
  }

  if (product_type.match(/letterpress/i) || components.some(function (_ref2) {
    var component_type = _ref2.component_type;
    return component_type.match(/letterpress/i);
  })) {
    return true;
  }

  return false;
}

function isSample(product_type) {
  return [PRODUCT_CONSTANTS.SILK_RIBBON_SAMPLES, PRODUCT_CONSTANTS.CLASSIC_WEDDING_INVITATION_SAMPLES, PRODUCT_CONSTANTS.LETTERPRESS_WEDDING_INVITATION_SAMPLES, PRODUCT_CONSTANTS.WEDDING_PLANNER_BOXES].includes(product_type);
}

function isEmbellishment(product_type) {
  return [PRODUCT_CONSTANTS.VELLUM_JACKETS, PRODUCT_CONSTANTS.WAX_SEALS, PRODUCT_CONSTANTS.SILK_RIBBON].includes(product_type);
}

function isCustomSample(product_type) {
  return [PRODUCT_CONSTANTS.CUSTOM_SAMPLES].includes(product_type);
}

function isTableNumbersOrSigns(product_type) {
  return [PRODUCT_CONSTANTS.TABLE_NUMBERS, PRODUCT_CONSTANTS.TABLE_NUMBER_REPRINTS, PRODUCT_CONSTANTS.RESERVED_SIGNS, PRODUCT_CONSTANTS.RESERVED_SIGN_REPRINTS, PRODUCT_CONSTANTS.WEDDING_SIGNS, PRODUCT_CONSTANTS.WEDDING_SIGN_REPRINTS // PRODUCT_CONSTANTS.CUSTOM_SAMPLES,
  ].includes(product_type);
}

function isCustomizable(product_type) {
  return !isTableNumbersOrSigns(product_type) && !isSample(product_type) && !isCustomSample(product_type) && !isEmbellishment(product_type);
}
/**
 * @class
 * @param {String} params.id
 * @param {String} params.oid
 * @param {String} params.designer_id
 * @param {Date} params.order_date
 * @param {Date} params.event_date
 * @param {String} params.status
 * @param {Date} params.approved_on_date
 * @param {Date} params.started_proofing_on_date
 * @param {Boolean} params.archived
 * @param {Array<Product>} params.products
 * @param {String} params.printing_type
 * @param {String} params.telephone
 * @param {String} params.lastname
 * @param {String} params.firstname
 * @param {String} params.address1
 * @param {String} params.address2
 * @param {String} params.city
 * @param {String} params.state
 * @param {String|Number} params.zip
 * @param {String} params.country
 * @param {Address} params.primary_shipping_address - overrides telephone, lastname, firstname, etc. if passed in
 * @param {Address} params.secondary_shipping_address
 * @param {Address} params.other_shipping_address
 * @param {String} params.small_shipment_shipping_address
 * @param {String} params.large_shipment_shipping_address
 * @param {String} params.letterpress_shipment_shipping_address
 * @param {String} params.envelopes_shipment_shipping_address
 * @param {Boolean} params.ship_envelopes_separately
 * @param {String} params.shipping_service
 * @param {String} params.designation_override - set designation manually
 * @param {Number} params.tax_rate
 * @param {Array<PriceAdjustment>} params.price_adjustments
 * @param {Number} params.client_payment
 * @param {Array<OrderNote>} params.notes
 *
 * @property {String} id
 * @property {String} order_id
 * @property {String} designer_id
 * @property {String} order_type - e.g. 'order', for the ShineOrders factory
 * @property {Array<String>} designations - e.g. 'orders' | 'table_numbers' | 'sample_orders'
 * @property {Boolean} archived - is it archived?
 * @property {Array<Product>} products - an order's products
 * @property {Array<String>} product_types - an array of product types
 * @property {Number} subtotal - sum of product costs
 * @property {Number} tax_rate - tax rate out of 100 (e.g. 8.000, NOT 0.08)
 * @property {Number} tax_amount - how much tax the order requires
 * @property {Number} client_payment - how much has the client paid?
 * @property {Array<PriceAdjustment>} price_adjustment - discounts or fees applied
 * @property {Boolean} qualifies_for_free_shipping - read only - is it over or under the free shipping threshold?
 * @property {String} printing_type - one of [ STD | RUSH | 1 DAY | 2 DAY ]
 * @property {Boolean} has_reprints
 * @property {Boolean} has_samples
 * @property {Boolean} has_letterpress
 * @property {Boolean} samples_only
 * @property {Boolean} reprints_and_spools_only
 * @property {Address} primary_shipping_address
 * @property {Address} secondary_shipping_address
 * @property {Address} other_shipping_address
 * @property {String} customer_name - read only
 * @property {String} telephone - telephone from primary shipping address
 * @property {String} firstname - firstname from primary shipping address
 * @property {String} lastname - lastname from primary shipping address
 * @property {String} address1 - address1 from primary shipping address
 * @property {String} address2 - address2 from primary shipping address
 * @property {String} city - city from primary shipping address
 * @property {String} state - state from primary shipping address
 * @property {String} zip - zip from primary shipping address
 * @property {String} country - country from primary shipping address
 * @property {String} small_shipment_shipping_address - one of [ primary_shipping_address | secondary_shipping_address | other_shipping_address ]
 * @property {String} large_shipment_shipping_address - one of [ primary_shipping_address | secondary_shipping_address | other_shipping_address ]
 * @property {String} letterpress_shipment_shipping_address - one of [ primary_shipping_address | secondary_shipping_address | other_shipping_address ]
 * @property {String} envelopes_shipment_shipping_address - one of [ primary_shipping_address | secondary_shipping_address | other_shipping_address ]
 * @property {Boolean} ship_envelopes_separately - is there a separate shipment of envelopes?
 * @property {Boolean} is_international - read only
 * @property {Boolean} is_canadian - read only
 * @property {String} internal_notes - read only - combination of all active notes into a string
 * @property {String} payment_string
 * @property {String} promo_code
 * @property {Object} SHIPPING_OPTIONS - list of shipping options - assigned by ShineOrders.initialize()
 * @property {Object} PRINTING_OPTIONS - list of printing options - assigned by ShineOrders.initialize()
 * @property {Array<PrintingOption>} PRINTING_OPTIONS.standard - list of printing options - assigned by ShineOrders.initialize()
 * @property {Array<PrintingOption>} PRINTING_OPTIONS.letterpress - list of printing options - assigned by ShineOrders.initialize()
 * @property {Number} FREE_SHIPPING_THRESHOLD - the threshold above which an order qualifies for free shipping - assigned by ShineOrders.initialize()
 */


var Order = /*#__PURE__*/function () {
  function Order() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Order);

    // keys
    this.id = params.id;
    this.oid = params.oid || params.id; // alternate order id

    this.designer_id = params.designer_id || '';
    this.customer_id = params.customer_id || ''; // attributes

    this.order_type = 'order';
    this.order_date = params.order_date ? moment(params.order_date).toISOString() : moment().toISOString();
    this.event_date = params.event_date ? moment(params.event_date).toISOString() : null;
    this.status = params.status || 'new';
    this.archived = parseBoolean(params.archived);
    this.approved_on_date = params.approved_on_date ? moment(params.approved_on_date).toISOString() : null;
    this.shipped_on_date = params.shipped_on_date ? moment(params.shipped_on_date).toISOString() : null;
    this.canceled_on_date = params.canceled_on_date ? moment(params.canceled_on_date).toISOString() : null;
    this.started_proofing_on_date = params.started_proofing_on_date ? moment(params.started_proofing_on_date).toISOString() : null;
    this.shipper_id = params.shipper_id || null;
    this.notes = params.notes && Array.isArray(params.notes) ? params.notes.map(function (note) {
      return new OrderNote(note);
    }) : [];
    this.email = (params.email || '').trim().toLowerCase();
    this.website_version = params.website_version || 4; // products

    this.products = params.products && Array.isArray(params.products) ? params.products.map(function (prod) {
      return ShineProducts.instance().make(_objectSpread(_objectSpread({}, prod), {}, {
        order_id: _this.id
      }));
    }) : []; // printing information

    this.printing_type = params.printing_type ? params.printing_type.toUpperCase() : 'STD'; // shipping information

    this.primary_shipping_address = params.primary_shipping_address ? new Address(params.primary_shipping_address) : new Address({
      telephone: params.telephone || '',
      lastname: params.lastname || '',
      firstname: params.firstname || '',
      address1: params.address1 || '',
      address2: params.address2 || '',
      city: params.city || '',
      state: params.state || '',
      zip: params.zip || '',
      country: params.country || 'US'
    });
    this.printable_files = parseBoolean(params.printable_files);
    this.secondary_shipping_address = params.secondary_shipping_address ? new Address(params.secondary_shipping_address) : null;
    this.other_shipping_address = params.other_shipping_address ? new Address(params.other_shipping_address) : null;
    this.small_shipment_shipping_address = params.small_shipment_shipping_address || 'primary_shipping_address';
    this.large_shipment_shipping_address = params.large_shipment_shipping_address || 'primary_shipping_address';
    this.letterpress_shipment_shipping_address = params.letterpress_shipment_shipping_address || 'primary_shipping_address';
    this.envelopes_shipment_shipping_address = params.envelopes_shipment_shipping_address || 'primary_shipping_address';
    this.sample_shipment_shipping_address = params.sample_shipment_shipping_address || 'primary_shipping_address';
    this.ship_envelopes_separately = parseBoolean(params.ship_envelopes_separately);
    this.sales_channel = params.sales_channel || null;
    this.special_request = params.special_request || null;
    this.designation_override = params.designation_override || null;
    this.is_influencer = parseBoolean(params.is_influencer);
    this.needs_assembly = parseBoolean(params.needs_assembly); // costs

    this.shipping_service = params.shipping_service || null;
    this.tax_rate = parseFloat(params.tax_rate, 10) || 0;
    this.price_adjustments = params.price_adjustments && Array.isArray(params.price_adjustments) ? params.price_adjustments.map(function (obj) {
      return new PriceAdjustment(obj);
    }) : [];
    this.client_payment = parseFloat(params.client_payment, 10) || 0;
    this.reprint_reason = params.reprint_reason || null;
    this.promo_code = params.promo_code || null;
    this.payment_string = params.payment_string || null;
    this.customer_label = params.customer_label || null;
    this.payment_type = params.payment_type || null;
    this.payment_info = params.payment_info || null;
    this.wedding_budget = params.wedding_budget || null;
  }

  _createClass(Order, [{
    key: "checkProductTypesFor",
    value: function checkProductTypesFor(exp) {
      for (var i = 0; i < this.products.length; i++) {
        var product = this.products[i];

        if (product.product_type.match(exp)) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "order_id",
    get: function get() {
      return this.id;
    },
    set: function set(id) {
      this.id = id;
    }
  }, {
    key: "qualifies_for_free_shipping",
    get: function get() {
      return ShineShipping.instance().qualifiesForFreeShipping(this);
    }
  }, {
    key: "product_types",
    get: function get() {
      return this.products.map(function (prod) {
        return prod.product_type;
      });
    }
  }, {
    key: "has_reprints",
    get: function get() {
      return this.checkProductTypesFor(new RegExp('reprint', 'ig'));
    }
  }, {
    key: "has_samples",
    get: function get() {
      return this.checkProductTypesFor(new RegExp('sample', 'ig'));
    }
  }, {
    key: "has_letterpress",
    get: function get() {
      return this.products.some(hasLetterpress);
    }
  }, {
    key: "lightweight_only",
    get: function get() {
      var product_types = this.product_types;

      if (product_types.length === 0) {
        return false;
      }

      var samplesOnly = true;

      for (var i = 0; i < product_types.length; i++) {
        if (![PRODUCT_CONSTANTS.SIGNS, PRODUCT_CONSTANTS.WEDDING_SIGNS, PRODUCT_CONSTANTS.SILK_RIBBON_SAMPLES, PRODUCT_CONSTANTS.CLASSIC_WEDDING_INVITATION_SAMPLES, PRODUCT_CONSTANTS.LETTERPRESS_WEDDING_INVITATION_SAMPLES, PRODUCT_CONSTANTS.TABLE_NUMBERS, PRODUCT_CONSTANTS.CUSTOM_SAMPLES].includes(product_types[i])) {
          // if package_type is neither of the above categories, shipping is not the discounted at the 'lightweight only' rate
          samplesOnly = false;
        }
      }

      return samplesOnly;
    }
  }, {
    key: "samples_only",
    get: function get() {
      var product_types = this.product_types;

      if (product_types.length === 0) {
        return false;
      }

      var samplesOnly = true;

      for (var i = 0; i < product_types.length; i++) {
        if (![PRODUCT_CONSTANTS.SILK_RIBBON_SAMPLES, PRODUCT_CONSTANTS.CLASSIC_WEDDING_INVITATION_SAMPLES, PRODUCT_CONSTANTS.LETTERPRESS_WEDDING_INVITATION_SAMPLES, PRODUCT_CONSTANTS.CUSTOM_SAMPLES].includes(product_types[i])) {
          // if package_type is neither signs, silk ribbon samples, letterpress/classic samples,
          // nor table numbers, shipping is not the discounted 'samplesOnly' rate
          samplesOnly = false;
        }
      }

      return samplesOnly;
    }
  }, {
    key: "reprints_and_spools_only",
    get: function get() {
      var product_types = this.product_types;

      if (product_types.length === 0) {
        return false;
      }

      var reprintsAndSpoolsOnly = true;

      for (var i = 0; i < product_types.length; i++) {
        if (product_types[i] !== PRODUCT_CONSTANTS.SILK_RIBBON && !product_types[i].match(/reprint/i)) {
          // if package_type is neither some kind of reprint nor silk ribbon spools,
          // shipping is not the discounted 'reprintsAndSpoolsOnly' rate
          reprintsAndSpoolsOnly = false;
        }
      }

      return reprintsAndSpoolsOnly;
    }
  }, {
    key: "designations",
    get: function get() {
      if (this.designation_override) {
        return [this.designation_override];
      }

      var designations = [];
      var product_types = this.product_types;
      var embellishments = product_types.filter(isEmbellishment);
      var sampleProducts = product_types.filter(isSample);
      var customSamples = product_types.filter(isCustomSample);
      var nonCustomizableStationery = product_types.filter(isTableNumbersOrSigns);
      var customizableStationery = product_types.filter(isCustomizable);

      if (customSamples.length) {
        designations.push(DESIGNATIONS.custom_samples);
      }

      if (customizableStationery.length) {
        designations.push(DESIGNATIONS.orders);
      } else if (nonCustomizableStationery.length) {
        designations.push(DESIGNATIONS.table_numbers);
      }

      if (sampleProducts.length || embellishments.length && designations.length === 0) {
        designations.push(DESIGNATIONS.sample_orders);
      }

      if (uniq(designations).length === 0) {
        return [DESIGNATIONS.orders];
      }

      return uniq(designations);
    }
  }, {
    key: "is_canadian",
    get: function get() {
      return this.country === 'CA';
    }
  }, {
    key: "is_international",
    get: function get() {
      return this.country !== 'US';
    }
    /**
       * @returns {Array<ShippingOption>}
       */

  }, {
    key: "shipping_options",
    get: function get() {
      return ShineShipping.instance().getShippingOptions(this);
    }
    /**
       * sets the shipping_service to the default
       */

  }, {
    key: "defaultShippingService",
    value: function defaultShippingService() {
      this.shipping_service = this.shipping_type.title;
    }
    /**
      * @returns {ShippingOption}
      */

  }, {
    key: "shipping_type",
    get: function get() {
      var _this2 = this;

      if (this.shipping_service) {
        // get shipping option object(s) with title(s) matching this.shipping_service
        var types = this.shipping_options.filter(function (opt) {
          return opt.title === _this2.shipping_service;
        }); // there should be (at least) 1, so return the first one.

        if (types.length > 0) {
          return types[0];
        } // otherwise, warn that this.shipping_service was not found
        // in the list of shipping objects for this order.


        console.warn("shipping_type must be one of ".concat(this.shipping_options.map(function (_ref3) {
          var title = _ref3.title;
          return title;
        }).join('/'), ".\nreceived ").concat(this.shipping_service));
      }

      return sortBy(this.shipping_options, ['rate'])[0];
    },
    set: function set(type) {
      var valid_types = this.shipping_options.map(function (_ref4) {
        var title = _ref4.title;
        return title;
      });

      if (valid_types.includes(type)) {
        this.shipping_service = type;
      } else {
        console.warn("shipping_type must be one of ".concat(valid_types.join('/'), ".\nreceived ").concat(type));
      }
    }
  }, {
    key: "shipping_amount",
    get: function get() {
      if (this.qualifies_for_free_shipping) {
        return this.shipping_type.freeRate;
      }

      return this.shipping_type.rate;
    }
  }, {
    key: "customer_name",
    get: function get() {
      return "".concat(this.primary_shipping_address.lastname, ", ").concat(this.primary_shipping_address.firstname);
    }
  }, {
    key: "first_last",
    get: function get() {
      return "".concat(this.primary_shipping_address.firstname, " ").concat(this.primary_shipping_address.lastname);
    }
  }, {
    key: "contact_email",
    get: function get() {
      return uniq(this.products.map(function (_ref5) {
        var contact_email = _ref5.contact_email;
        return contact_email;
      }).filter(function (a) {
        return a;
      }));
    }
  }, {
    key: "firstname",
    get: function get() {
      return this.primary_shipping_address.firstname;
    },
    set: function set(str) {
      this.primary_shipping_address.firstname = str;
    }
  }, {
    key: "lastname",
    get: function get() {
      return this.primary_shipping_address.lastname;
    },
    set: function set(str) {
      this.primary_shipping_address.lastname = str;
    }
  }, {
    key: "telephone",
    get: function get() {
      return this.primary_shipping_address.telephone;
    },
    set: function set(str) {
      this.primary_shipping_address.telephone = str;
    }
  }, {
    key: "address1",
    get: function get() {
      return this.primary_shipping_address.address1;
    },
    set: function set(str) {
      this.primary_shipping_address.address1 = str;
    }
  }, {
    key: "address2",
    get: function get() {
      return this.primary_shipping_address.address2;
    },
    set: function set(str) {
      this.primary_shipping_address.address2 = str;
    }
  }, {
    key: "city",
    get: function get() {
      return this.primary_shipping_address.city;
    },
    set: function set(str) {
      this.primary_shipping_address.city = str;
    }
  }, {
    key: "state",
    get: function get() {
      return this.primary_shipping_address.state;
    },
    set: function set(str) {
      this.primary_shipping_address.state = str;
    }
  }, {
    key: "zip",
    get: function get() {
      return this.primary_shipping_address.zip;
    },
    set: function set(str) {
      this.primary_shipping_address.zip = str;
    }
  }, {
    key: "country",
    get: function get() {
      return this.primary_shipping_address.country.slice(0, 2).toUpperCase();
    },
    set: function set(c) {
      this.primary_shipping_address.country = c.slice(0, 2).toUpperCase();
    }
  }, {
    key: "printing_options",
    get: function get() {
      return ShinePrinting.instance().getPrintingOptions(this);
    }
  }, {
    key: "printing_option",
    get: function get() {
      var _this3 = this;

      var printing_options = this.printing_options.filter(function (_ref6) {
        var key = _ref6.key;
        return key === _this3.printing_type;
      });

      if (printing_options.length > 0) {
        if (printing_options.length > 1) {
          console.warn("".concat(this.printing_type, " matched more than one printing option"));
        }
      } else {
        return {
          value: 0,
          invalid: true,
          message: "printing_type must match one of ".concat(this.printing_options.map(function (_ref7) {
            var key = _ref7.key;
            return key;
          }).join('/'), ". Received ").concat(this.printing_type)
        };
      }

      return printing_options[0];
    }
  }, {
    key: "printing_amount",
    get: function get() {
      var printing_amount = this.printing_option.value;

      if (Object.prototype.toString.call(printing_amount) === '[object Object]') {
        return ShinePricing.instance().calculatePrintingAmount(this, printing_amount.functions);
      }

      return printing_amount;
    }
  }, {
    key: "tax_amount",
    get: function get() {
      var taxable = [parseFloat(this.shipping_amount, 10), parseFloat(this.printing_amount, 10), parseFloat(this.subtotal, 10), parseFloat(this.price_adjustment, 10)].reduce(function (p, v) {
        return p + v;
      }, 0);
      return taxable * parseFloat(this.tax_rate, 10) / 100;
    }
  }, {
    key: "subtotal",
    get: function get() {
      return this.products.map(function (prod) {
        return prod.subtotal;
      }).reduce(function (p, v) {
        return p + v;
      }, 0);
    }
    /**
       * @returns {Array<PriceAdjustment>}
       */

  }, {
    key: "dollar_adjustments",
    get: function get() {
      return this.price_adjustments.map(function (obj) {
        return new PriceAdjustment(obj);
      }).filter(function (_ref8) {
        var units = _ref8.units;
        return units === 'dollars';
      });
    }
    /**
       * @returns {Array<PriceAdjustment>}
       */

  }, {
    key: "percent_adjustments",
    get: function get() {
      return this.price_adjustments.map(function (obj) {
        return new PriceAdjustment(obj);
      }).filter(function (_ref9) {
        var units = _ref9.units;
        return units === 'percent';
      });
    }
    /**
       * @returns {Number}
       */

  }, {
    key: "price_adjustment",
    get: function get() {
      var subtotal = this.subtotal;
      var dollar_adjustment = this.dollar_adjustments.map(function (_ref10) {
        var value = _ref10.value;
        return value;
      }).reduce(function (p, v) {
        return p + v;
      }, 0);
      var adjusted_subtotal = subtotal + dollar_adjustment;
      var percent_adjustments = this.percent_adjustments.map(function (_ref11) {
        var value = _ref11.value;
        return value;
      }).reduce(function (p, v) {
        return p + v;
      }, 0);
      var percent_adjustment = adjusted_subtotal * percent_adjustments / 100;
      return dollar_adjustment + percent_adjustment;
    }
  }, {
    key: "discounts",
    get: function get() {
      return this.price_adjustments.map(function (obj) {
        return new PriceAdjustment(obj);
      }).filter(function (_ref12) {
        var type = _ref12.type;
        return type === 'discount';
      });
    }
  }, {
    key: "fees",
    get: function get() {
      return this.price_adjustments.map(function (obj) {
        return new PriceAdjustment(obj);
      }).filter(function (_ref13) {
        var type = _ref13.type;
        return type === 'fee';
      });
    }
  }, {
    key: "total_price",
    get: function get() {
      var total_price = [parseFloat(this.subtotal, 10), parseFloat(this.shipping_amount, 10), parseFloat(this.printing_amount, 10), parseFloat(this.tax_amount, 10), parseFloat(this.price_adjustment, 10)].reduce(function (p, v) {
        return p + v;
      }, 0);
      return Math.round(total_price * 100) / 100;
    }
  }, {
    key: "balance",
    get: function get() {
      return (Math.round(this.client_payment * 100, 10) - Math.round(this.total_price * 100, 10)) / 100;
    }
  }, {
    key: "payment_status",
    get: function get() {
      if (this.balance > 0) {
        return 'credit';
      }

      if (this.balance < 0) {
        return 'needs payment';
      }

      return 'paid';
    }
    /**
       * @returns {String}
       */

  }, {
    key: "internal_notes",
    get: function get() {
      return this.notes.filter(function (_ref14) {
        var active = _ref14.active;
        return active;
      }).map(function (_ref15) {
        var text = _ref15.text;
        return text;
      }).join('\r\r');
    }
  }, {
    key: "minify",
    value: function minify() {
      return {
        id: this.id,
        oid: this.oid,
        customer_id: this.customer_id,
        archived: this.archived,
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email,
        designations: this.designations,
        order_type: this.order_type,
        order_date: this.order_date,
        printing_type: this.printing_type,
        sales_channel: this.sales_channel,
        designer_id: this.designer_id,
        status: this.status,
        payment_status: this.payment_status,
        total_price: this.total_price,
        started_proofing_on_date: this.started_proofing_on_date,
        shipper_id: this.shipper_id,
        product_types: this.product_types,
        notes: this.internal_notes,
        notify_shippers: this.internal_notes.length > 0
      };
    }
  }]);

  return Order;
}();

module.exports = Order;